export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 90,
    showHeaderOverflow: true,
    slots: { default: 'opt' }
  },
  {
    title: that.$l('INDEX.notice_label_noticeOrderNo') || '订单通知书编号',
    field: 'noticeOrderNo',
    width: 160,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.notice_label_noticeOrderStatus') || '处理状态',
    field: 'noticeOrderStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'showNoticeOrderStatus' }
  },
  {
    title: that.$l('INDEX.notice_label_noticeByName') || '通知人',
    field: 'noticeByName',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'showNoticeByName' }
  },
  {
    title: that.$l('INDEX.order_form_label_orderNo') || '订单编号',
    field: 'orderNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    width: 160,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_custCode') || '下单客户',
    field: 'custName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_endCustCode') || '终端客户',
    field: 'endCustName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_brand') || '客户品牌',
    field: 'brandName',
    width: 120,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_salesPersonCode') || '业务人员名字',
    field: 'salesPersonName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_bizPersonCode') || '跟单人员',
    field: 'bizPersonName',
    align: 'center',
    width: 150,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_orderType') || '订单类型',
    field: 'v_orderType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_orderExecuteType') || '执行方式',
    field: 'v_orderExecuteType',
    width: 120,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_orderSource') || '订单来源',
    field: 'v_orderSource',
    width: 200,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_importanceLevel') || '订单性质',
    field: 'v_importanceLevel',
    width: 150,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_scmCode') || '执行工厂',
    field: 'scmName',
    width: 200,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_orderScmCode') || '名义工厂',
    field: 'orderScmCodeName',
    width: 200,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_settlementFactory') || '结算工厂',
    field: 'settlementFactoryName',
    width: 200,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_Total_order_cost') || '订单总价',
    field: 'orderAmount',
    width: 160,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    slots: { default: 'showOrderAmount' }
  },
  {
    title:
      that.$l('INDEX.order_form_label_factoryPaymentTerms') || '工厂付款条件',
    field: 'v_factoryPaymentTerms',
    width: 200,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_orderStatus') || '订单状态',
    field: 'v_orderStatus',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' }
  }
]
